window.$ = window.jQuery = require('jquery');
require('popper.js/dist/popper.min');
window.bootstrap = require('bootstrap');
require('jquery-nice-select/js/jquery.nice-select.min');
require('vgformsender/dist/js/vgformsender.min');

require('../../vendor/fancybox/jquery.fancybox');
require('../../vendor/inputmask/jquery.inputmask');
require('../../vendor/ion/ion.rangeSlider.min');

require('./modules/store/basket');
require('./modules/store/fav');
require('./modules/store/constructor');
require('./modules/store/order');
require('./modules/store/store');

require('./modules/auth');
require('./modules/carousel');
require('./modules/modal');
require('./modules/vegas');
require('./modules/ym');
require('./../../vendor/functions');

// [[vegas]]
require('./custom');
